import guid from "@ciaopeople/cp-shatsu/Utils";
import { CPProductName } from "../../../config/CPProducts.js";
import { YMCiaopeopleSite, linearizeToYMCiaopeopleSite } from "../../../config/YMCiaopeopleSite.js";
import { GenericQSStatsCollector } from "./GenericQSStatsCollector.js";
import { MediaId } from "../../../model/MediaInfo.js";



interface CData {
    
    id: string, // collector-id
    v: string, // player version
    src: "web", //source context
    l: string, //label
    sl: string, // sub label
    ts: number, // timestamp
    vid: MediaId,
    eu: string, //embed url
    rf?: string, //referral
    d: YMCiaopeopleSite // site

}

/**
 * Collects and sends statistics events for YM source players.
 * 
 * Extends `GenericQSStatsCollector` to provide specialized event collection for YM sources.
 * 
 * @remarks
 * - Generates a unique collector ID for each instance.
 * - Uses the provided `window` object to access location and referrer information.
 * - Events are collected only if all required parameters are provided.
 * 
 * @example
 * ```typescript
 * const collector = new YMSourceStatsCollector(window, "https://stats.example.com");
 * collector.collectEvent("video123", "play", "start", "ciaopeople", "1.0.0");
 * ```
 */
export class YMSourceStatsCollector extends GenericQSStatsCollector {

    private collectorId: string;

    constructor(private window: Window, bUrl: string) {
        super("YMSrcStats",bUrl);
        this.collectorId = guid();
    }


    public collectEvent(videoId: MediaId, label: string, subLabel: string, site: CPProductName | YMCiaopeopleSite, playerVersion: string = "parthenope"): Promise<void> {
        
        const usite = linearizeToYMCiaopeopleSite(site);
        if(usite && videoId && videoId != "" && label && label != "" && subLabel && subLabel != "") {

            
            const data: CData = {
                id: this.collectorId,
                v: playerVersion,
                src: "web",
                l: label,
                sl: subLabel,
                ts: new Date().getTime(),
                vid: videoId,
                eu: this.window.location.href.toString(),
                d: usite
            };
            if(document.referrer) data.rf = document.referrer.toString();
            return this.collect("GET", data);
        }
        else return Promise.reject("Missing label and/or sublabel and/or videoid and/or site");

    }



}